const { default: axiosInstance } = require("utils/axios");

const getConsignmentCarsList = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-consingment/get-all-car", {
      params: filter,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching consignment cars:", error);
    throw error;
  }
};

const getConsignmentCarById = async (id) => {
  try {
    const response = await axiosInstance.get(`/car-consingment/get-car/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching consignment car by ID:", error);
    throw error;
  }
};

const createOrderConsignmentCar = async (data) => {
  const formData = new FormData();

  formData.append("customer_data", JSON.stringify(data.customer_data));
  formData.append("car_data", JSON.stringify(data.car_data));
  formData.append("consignment_data", JSON.stringify(data.consignment_data));

  if (data.image && data.image.length > 0) {
    data.image.forEach((file) => {
      formData.append("image", file);
    });
  }
  if (data.car_photos && data.car_photos.length > 0) {
    data.car_photos.forEach((file) => {
      formData.append("car_photos", file);
    });
  }

  try {
    const response = await axiosInstance.post(
      "/car-consingment/createCarOrder",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating consignment car:", error);
    throw error;
  }
};

const updateConsignmentCar = async (id, data) => {
  const formData = new FormData();

  if (data.car_data) {
    formData.append("car_data", JSON.stringify(data.car_data));
  }
  if (data.consignment_data) {
    formData.append("consignment_data", JSON.stringify(data.consignment_data));
  }
  if (data.car_photos && data.car_photos.length > 0) {
    data.car_photos.forEach((file) => {
      formData.append("car_photos", file);
    });
  }

  try {
    const response = await axiosInstance.put(
      `/car-consingment/updateCar/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating consignment car:", error);
    throw error;
  }
};

const deleteCarPictures = async (ids) => {
  try {
    const response = await axiosInstance.post(
      `/car-consingment/deleteCarPics`,
      { data: { ids } }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting car pictures:", error);
    throw error;
  }
};

const printPdfConsignmetContact = async (document_id) => {
  try {
    return await axiosInstance.get(
      `/car-consingment/print-consign-contact/${document_id}`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    console.error("Error printing consignment contract:", error);
    throw error;
  }
};

const createConsignmentContract = async (data, order_id) => {
  try {
    const response = await axiosInstance.post(
      `/car-consingment/create-car-consingment-contact/${order_id}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error creating consignment contract:", error);
    throw error;
  }
};

const getConsignmentContractById = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-consingment/get-car-consingment-contact/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching consignment contract by ID:", error);
    throw error;
  }
};

const ConsignmentCarService = {
  getConsignmentCarsList,
  createOrderConsignmentCar,
  getConsignmentCarById,
  updateConsignmentCar,
  deleteCarPictures,
  printPdfConsignmetContact,
  createConsignmentContract,
  getConsignmentContractById,
};
export default ConsignmentCarService;
